<div mat-dialog-content>{{message}}</div>
<div mat-dialog-actions class="button-position">
    <button>Confirm</button>
    <button>Cancel</button>
</div>